/** Single-series bars in ink, the latest in the accent; read as a table by screen readers. */
export function Bars({ values, axis, summary }: {
  values: { key: string; value: number; label: string }[]
  axis: string[]
  summary: string
}) {
  const max = Math.max(1, ...values.map(v => v.value))
  return (
    <figure className="ml-stats__chart">
      <div className="ml-stats__bars" aria-hidden="true">
        {values.map((v, i) => (
          <span key={v.key} className={`ml-stats__bar${i === values.length - 1 ? ' is-latest' : ''}`} title={v.label}>
            <span style={{ height: `${v.value > 0 ? Math.max(6, (v.value / max) * 100) : 0}%` }} />
          </span>
        ))}
      </div>
      <figcaption className={`ml-stats__axis${axis.length === 2 ? ' is-ends' : ''}`} aria-hidden="true">
        {axis.map((a, i) => <span key={`${a}-${i}`}>{a}</span>)}
      </figcaption>
      <table className="ml-visually-hidden">
        <caption>{summary}</caption>
        <tbody>{values.map(v => <tr key={v.key}><td>{v.label}</td></tr>)}</tbody>
      </table>
    </figure>
  )
}
